import { HiOutlineClock } from "react-icons/hi"
import { IoCheckmarkDoneOutline, IoCheckmarkOutline } from "react-icons/io5"
import { dateTimeFunction } from "utils/date"
import { DATE_FORMAT, TIME_FORMAT } from "constants"
import { localisedValue } from "utils"

export function getTickIcon(status, styles) {
  const isOverlay = styles.tickColor === "white"
  const getTickClass = (variant) => {
    const baseClass = styles.msgTick
    const variantClass = isOverlay ? styles.white : styles[variant]
    return `${baseClass} ${variantClass || ''}`
  }
  
  switch (status) {
    case 1:
      return <HiOutlineClock className={getTickClass('error')} />
    case 2:
      return <IoCheckmarkOutline className={getTickClass('error')} />
    case 3:
      return <IoCheckmarkOutline className={getTickClass('sent')} />
    case 4:
      return <IoCheckmarkOutline className={getTickClass('sent')} />
    case 5:
      return <IoCheckmarkDoneOutline className={getTickClass('read')} />
    case 6:
      return <IoCheckmarkDoneOutline className={getTickClass('read')} />
    default:
  }
}

export function startsWithVowel(str) {
  if (!str || typeof str !== 'string') return false
  const firstChar = str.charAt(0).toLowerCase()
  return ['a', 'e', 'i', 'o', 'u'].includes(firstChar)
}

// Validation helpers
export const isValidMessage = (message) => {
  return message && typeof message === 'object' && message.id
}

export const isValidTimestamp = (timestamp) => {
  if (!timestamp) return false
  const date = new Date(timestamp)
  return !isNaN(date.getTime())
}

// Safe JSON parsing helper
export const safeJSONParse = (content, fallback = null) => {
  try {
    return JSON.parse(content)
  } catch {
    return fallback
  }
}

export const safeArrayOperation = (array, operation, fallback = []) => {
  try {
    if (!Array.isArray(array)) return fallback
    return operation(array)
  } catch (error) {
    console.warn('Array operation failed:', error)
    return fallback
  }
}

export const formatDateForDisplay = (dateString) => {
  const date = new Date(dateString)
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  if (date.toDateString() === today.toDateString()) {
    return "Today"
  } else if (date.toDateString() === yesterday.toDateString()) {
    return "Yesterday"
  } else {
    return dateTimeFunction({ date: dateString, format: DATE_FORMAT })
  }
}

export const formatMessageTime = (timestamp) => {
  return dateTimeFunction({ date: timestamp, format: TIME_FORMAT })
}

export const getMessageStatus = (message) => {
  if (message.WhatsAppChatMessageStatus) {
    const statusKey = message.WhatsAppChatMessageStatus.key
    switch (statusKey) {
      case 'sent':
        return 'sent'
      case 'delivered':
        return 'delivered'
      case 'read':
        return '1'
      case 'error':
        return 'error'
      default:
        return null
    }
  }
  return null
}

export const isDateSeparator = (message) => {
  return message.type === "date" || message.contentType === "date"
}

export const addDateSeparators = (messages) => {
  if (!messages || !Array.isArray(messages) || messages.length === 0) return []

  try {
    const actualMessages = JSON.parse(JSON.stringify(messages)).filter(msg => !isDateSeparator(msg))
    if (actualMessages.length === 0) return []
    const transformedMessages = []
    let currentDate = null

    const sortedMessages = [...actualMessages].sort((a, b) => {
      const dateA = new Date(a.messageTimestamp)
      const dateB = new Date(b.messageTimestamp)
      if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
        return 0
      }
      return dateA - dateB
    })

    sortedMessages.forEach((message) => {
      try {
        const messageDate = new Date(message.messageTimestamp)
        if (isNaN(messageDate.getTime())) {
          transformedMessages.push(message)
          return
        }
        const messageDateString = messageDate.toDateString()
        if (currentDate !== messageDateString) {
          currentDate = messageDateString
          const dateId = `date-separator-${messageDateString.replace(/\s+/g, '-')}`
          const dateSeparator = {
            id: dateId,
            contentType: "date",
            content: JSON.stringify({
              type: "date",
              date: messageDateString,
              s3KeyValue: null
            }),
            sentBy: "system",
            messageTimestamp: message.messageTimestamp,
            type: "date",
            text: formatDateForDisplay(messageDateString)
          }
          transformedMessages.push(dateSeparator)
        }
        transformedMessages.push(message)
      } catch (msgError) {
        console.warn('Error processing message for date separator:', msgError)
        transformedMessages.push(message)
      }
    })

    return transformedMessages
  } catch (error) {
    console.error('Error adding date separators:', error)
    return Array.isArray(messages) ? messages : []
  }
} 
export const getLocalizedWhatsAppMessage = (message, translationEn, translationAr) => {
  if (!translationEn && !translationAr) return message

  const localizedContent = {
    textEN: safeJSONParse(translationEn)?.message,
    textAR: safeJSONParse(translationAr)?.message,
  }

  return localisedValue({ object: localizedContent, key: "text" }) || message
}